import { all, call, put, takeLatest } from 'redux-saga/effects';

import {
  administratorsRequest,
  administratorsSuccess,
  administratorsFailure,
  createAdministratorSuccess,
  createAdministratorFailure,
  createAdministratorRequest,
  administratorRequest,
  administratorSuccess,
  administratorFailure,
  updateAdministratorRequest,
  updateAdministratorSuccess,
  updateAdministratorFailure,
  updateAdministratorStatusSuccess,
  updateAdministratorStatusFailure,
  updateAdministratorStatusRequest,
  deleteAdministratorSuccess,
  deleteAdministratorFailure,
  deleteAdministratorRequest,
} from './actions';
import axios from 'axios';
import { ADMINISTRATORS } from 'app/api-routes';

function* administratorsSaga() {
  try {
    const { payload, warnings } = yield axios.get(ADMINISTRATORS);

    yield put(administratorsSuccess(payload, { warnings }));
  } catch (err) {
    yield put(administratorsFailure(err));
  }
}

function* administratorSaga({ payload: administratorID }) {
  try {
    const { payload, warnings } = yield axios.get(`${ADMINISTRATORS}/${administratorID}`);

    yield put(administratorSuccess(payload, { warnings }));
  } catch (err) {
    yield put(administratorFailure(err));
  }
}

function* createAdministratorSaga({ payload, meta }) {
  try {
    const { payload: administratorID } = yield axios.post(ADMINISTRATORS, { payload });

    yield put(createAdministratorSuccess(administratorID));
    meta?.onSuccess?.(administratorID);
  } catch (err) {
    yield put(createAdministratorFailure(err));
    meta?.onFailure?.(err);
  } finally {
    meta?.onFinally?.();
  }
}

function* updateAdministratorSaga({ payload: { administratorID, payload }, meta }) {
  try {
    yield axios.put(`${ADMINISTRATORS}/${administratorID}`, { payload });

    yield put(updateAdministratorSuccess(administratorID));
    yield call(administratorSaga, { payload: administratorID });
    meta?.onSuccess?.(administratorID);
  } catch (err) {
    yield put(updateAdministratorFailure(err));
    meta?.onFailure?.(err);
  } finally {
    meta?.onFinally?.();
  }
}

function* updateAdministratorStatusSaga({ payload: { status, administratorID }, meta }) {
  try {
    yield axios.put(`${ADMINISTRATORS}/${administratorID}/status`, { payload: status });

    yield put(updateAdministratorStatusSuccess({ administratorID, status }));
    meta?.onSuccess?.(administratorID);
  } catch (err) {
    yield put(updateAdministratorStatusFailure(err));
    meta?.onFailure?.(err);
  } finally {
    meta?.onFinally?.();
  }
}

function* deleteAdministratorSaga({ payload: administratorID, meta }) {
  try {
    yield axios.delete(`${ADMINISTRATORS}/${administratorID}`);

    yield put(deleteAdministratorSuccess(administratorID));
    meta?.onSuccess?.(administratorID);
  } catch (err) {
    yield put(deleteAdministratorFailure(err));
    meta?.onFailure?.(err);
  } finally {
    meta?.onFinally?.();
  }
}

export default function* () {
  yield all([
    yield takeLatest(administratorsRequest, administratorsSaga),
    yield takeLatest(administratorRequest, administratorSaga),
    yield takeLatest(createAdministratorRequest, createAdministratorSaga),
    yield takeLatest(updateAdministratorRequest, updateAdministratorSaga),
    yield takeLatest(updateAdministratorStatusRequest, updateAdministratorStatusSaga),
    yield takeLatest(deleteAdministratorRequest, deleteAdministratorSaga),
  ]);
}
